module.exports = __webpack_public_path__ + "media/images/voice09-2-90648b8a7c69822ca64918f4b78adf2f.jpg";